module.exports = __webpack_public_path__ + "img/16.9b1a2ed1.jpg";